import { useSelector } from 'react-redux';

import { useMemo } from 'react';

import { selectBannerPuids } from 'shared/selectors/adfox';
import { selectRegionId } from 'shared/selectors/location';
import { TAdBannerCommonParameters } from 'shared/types/adBannerMicrofrontend';

import { generateRandomString } from '../utils';

/**
 * Общие для всех мест параметры баннера: puids и регион хоста плюс стабильный
 * идентификатор смонтированного баннера.
 */
export function useAdBannerCommonParameters(): TAdBannerCommonParameters {
  const bannerPuids = useSelector(selectBannerPuids);
  const regionId = useSelector(selectRegionId);

  const placeId = useMemo(() => generateRandomString(), []);

  const puids = useMemo<Record<string, string>>(
    () =>
      Object.entries(bannerPuids).reduce<Record<string, string>>((accumulator, [key, value]) => {
        if (value) {
          accumulator[key] = value;
        }

        return accumulator;
      }, {}),
    [bannerPuids],
  );

  return useMemo(() => ({ placeId, puids, regionId }), [placeId, puids, regionId]);
}
